module.exports = __webpack_public_path__ + "media/images/svg/cursor-icon-image-cbd943c4ea4fa5abfb3ed2653f67a280.svg";